import React from 'react';
import BrandLogo from '../BrandLogo/BrandLogo';
import { GameLoadState } from './useGameLoadState';
import styles from './GameLoadingSplash.module.css';

interface GameLoadingSplashProps {
  state: GameLoadState;
}

// Our logo over the game iframe until the game is ready — see useGameLoadState.
const GameLoadingSplash: React.FC<GameLoadingSplashProps> = ({ state }) => {
  if (state.phase === 'gone') return null;
  return (
    <div className={`${styles.splash} ${state.phase === 'hiding' ? styles.hiding : ''}`}>
      <BrandLogo className={styles.logo} />
      <div className={styles.track}>
        {state.progress === null ? (
          <div className={`${styles.fill} ${styles.indeterminate}`} />
        ) : (
          <div className={styles.fill} style={{ width: `${state.progress}%` }} />
        )}
      </div>
    </div>
  );
};

export default GameLoadingSplash;
